import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function selectedRoleReducer(state = initialState.selectedRole, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_ROLE_SUCCESS:
      return action.selectedRole;
    default:
      return state;
  }
}
